import * as React from "react"
const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={12} fill="none">
    <path
      fill="#E21824"
      d="M8.184 4v6.667H2.85V4h5.333Zm-1-4H3.85l-.667.667H.85V2h9.333V.667H7.85L7.184 0Zm2.333 2.667h-8v8c0 .733.6 1.333 1.334 1.333h5.333c.733 0 1.333-.6 1.333-1.333v-8Z"
    />
  </svg>
)
export default DeleteIcon
